import React from 'react';

interface CertificationVerifiedSvgProps {
  width?: number;
  height?: number;
  className?: string;
}

const CertificationVerifiedSvg: React.FC<CertificationVerifiedSvgProps> = ({
  width = 18,
  height = 18,
  className,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="1 1 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M6.27675 14.608L8.49988 14.0522L10.723 14.608L12.0688 12.7533L14.129 11.75L13.9678 9.46414L14.9011 7.37129L13.3083 5.72388L12.678 3.52071L10.3989 3.28261L8.49988 2L6.60091 3.28261L4.32176 3.52071L3.69151 5.72388L2.09863 7.37129L3.032 9.46414L2.87072 11.75L4.93098 12.7533L6.27675 14.608ZM6.85344 8.14645L7.49989 8.79289L10.1463 6.14645C10.3416 5.95118 10.6582 5.95118 10.8534 6.14645C11.0487 6.34171 11.0487 6.65829 10.8534 6.85355L7.49989 10.2071L6.14633 8.85355C5.95107 8.65829 5.95107 8.34171 6.14633 8.14645C6.34159 7.95118 6.65818 7.95118 6.85344 8.14645Z"
        fill="#000624"
      />
    </svg>
  );
};

export default CertificationVerifiedSvg;
